export interface SlateApi {}
